<template>
  <HoverDropdownMenu
    id="appHeader-to-wallet"
    :items="walletMenuItems"
    :item-width="180"
    class="wallet appheader-wallet-menu"
    :style="{'z-index': 20000}"
    popper-class="wallet-menu-popper"
    @visible-change="walletArrow = $event"
    @select="selectWalletMenu"
  >
    <Row class="wallet-active px-12px">
      <IconSvg v-if="!isSmallScreen" class="text-white! title transition pointer font-20" name="icon-asset" />
      <Row class="text-white! pointer h-20 transition bold font-14 ml-6px" :style="{'white-space':'nowrap'}">
        {{ $t("userCenter.assets") }}
      </Row>
      <IconSvg
        class="font-8 transition pointer text-white! ml-6px"
        :class="walletArrow ? 'rotateZ-180' : ''"
        :name="'icon-IconDown_Menu'"
      />
    </Row>

    <template #item="{ item }">
      <span v-inmodule="[item.path]" :test-key="item.key">{{ item.label }}</span>
    </template>
  </HoverDropdownMenu>
</template>

<script setup>
import { getBusinessPath } from '@/utils/localeRoute.js'

const route = useRoute()
const businessPath = $computed(() => getBusinessPath(route.path))
const walletArrow = $ref(false)
const walletMenuItems = $computed(() => [
  { key: 'walletOverview', path: '/wallet/walletOverview', label: $t('wallet.assetsOverview'), active: businessPath.includes('walletOverview'), class: 'appheader-dropdown-item bold' },
  { key: 'spotAccount', path: '/wallet/spotAccount', label: $t('wallet.spotAccount'), active: businessPath.includes('spotAccount'), class: 'appheader-dropdown-item bold' },
  { key: 'futures', path: '/wallet/futures', label: $t('wallet.futures'), active: businessPath === '/wallet/futures', class: 'appheader-dropdown-item bold' },
  { key: 'financialAccount', path: '/wallet/financialAccount', label: $t('wallet.financialAccount'), active: businessPath.includes('financialAccount'), class: 'appheader-dropdown-item bold' },
  { key: 'fiatAccount', path: '/wallet/fiatAccount', label: $t('wallet.fiatAccount'), active: businessPath.includes('fiatAccount'), class: 'appheader-dropdown-item bold' },
  { key: 'walletHistory', path: '/wallet/walletHistory', label: $t('wallet.assetsHistory'), active: businessPath.includes('walletHistory'), class: 'appheader-dropdown-item bold' },
  { key: 'assetProof', path: '/wallet/assetProof', label: $t('wallet.assetProof'), active: businessPath.includes('assetProof'), class: 'appheader-dropdown-item bold' },
])

const selectWalletMenu = key => {
  const item = walletMenuItems.find(({ key: itemKey }) => itemKey === key)
  if (item) toRouter(item.path)
}

const props = defineProps({
  isSmallScreen: {
    required: true,
  }
})
</script>

<style lang="scss">
.appheader-wallet-menu{
  --el-text-color-regular: var(--51AandWhite);
}

.wallet-menu-popper.el-popper {
  width: 204px !important;
}

.wallet-menu-popper .el-dropdown-menu__item:not(.is-disabled):hover,
.wallet-menu-popper .el-dropdown-menu__item:not(.is-disabled):focus {
  color: var(--16151A) !important;
}

.wallet-menu-popper .el-dropdown-menu__item.appheader-dropdown-item {
  padding-right: 12px;
  padding-left: 12px;
}

.wallet-active {
  border-radius: 999px;
  min-height: 32px;
  background-color: transparent !important;
  outline: none !important;

  &:hover, &:focus, &:active, &:focus-visible, &:focus-within {
    background-color: transparent !important;
    outline: none !important;
  }
}
</style>
